module.exports = __webpack_public_path__ + "d09d53170fcc7b1b34f197c2c6cdbe9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_kathleen_mobile_teaser.jpg
// module id = 672
// module chunks = 0